import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image";
import PortableText from "./portableText";
import clientConfig from "../../client-config";
import CTALink from "./CTALink";
import { convertToBgImage } from "gbimage-bridge"
import BackgroundImage from 'gatsby-background-image'

import { getGatsbyImageData } from "gatsby-source-sanity";

import * as styles from "./hero-image.module.css";

//props/variables are fed in from page.js

//background image behind the content
const maybeImage = illustration => {
  let img = null;
  if (illustration && illustration.image && illustration.image.asset && !illustration.disabled) {
    const imageData = getGatsbyImageData(
      illustration.image,
      { maxWidth: 960 },
      clientConfig.sanity
    );

    img = convertToBgImage(imageData);
  }
  return img;
};

//small image with the text
const maybeIcon = icon => {
  let iconImg = null;
  if (icon && icon.image && icon.image.asset && !icon.disabled) {
    const iconData = getGatsbyImageData(
      icon.image,
      { maxWidth: 960 },
      clientConfig.sanity
    );

    iconImg = <GatsbyImage
      className="w-40 h-40 mr-8 text-center"
      image={iconData}
      alt={icon.image.alt}
    />
  }
  return iconImg;
};

//although its labled half image, it currently set to take 3/4s the device height. 
function HeroHalfImage(props) {
  const img = maybeImage(props.illustration);
  const iconImg = maybeIcon(props.icon);
  return (
    <section 
      className={`${styles.heroHalf} ${props.mobmargin} md:${props.margin}`}
    >
    <BackgroundImage
      // Spread bgImage into BackgroundImage:
      {...img}
      id={`herobg`}
      preserveStackingContext
    >
      <div className={`${styles.halfCover} py-32 md:flex md:justify-center md:items-center`}>
        <div className="container px-3 mx-apy-32uto flex flex-wrap flex-col md:flex-row items-center"    >
          {/* Left col */}
          <div className="flex-col">{iconImg}</div>
          {/* Right col */}
          <div className="flex max-w-5xl flex-col justify-center items-start text-left">
            <p className="uppercase tracking-loose w-full">{props.label}</p>
            <h1 className="my-4 text-4xl md:text-5xl font-bold leading-tight">{props.heading}</h1>
            <div className="leading-normal text-lg md:text-xl">
              <PortableText blocks={props.tagline} />
            </div>
            {props.cta && props.cta.title && (
              <CTALink
                {...props.cta}
                buttonActionClass="bg-green-500 text-white-800 btnstyle mx-auto md:mx-0"
                linkActionClass="hover:underline text-green-500 font-bold"
              />
            )}
          </div>
        </div>
      </div>
      </BackgroundImage>
    </section>
  );
}

export default HeroHalfImage;